import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ISettingsState {
    isFullPrice: boolean;
    printWithPhone: boolean;
    currency: {
        code: string;
        exchangeRate: string;
    };
}

const initialState: ISettingsState = {
    isFullPrice: true,
    printWithPhone: false,
    currency: localStorage.getItem('currency')
        ? JSON.parse(localStorage.getItem('currency')!)
        : {
              code: 'AZN',
              exchangeRate: '1',
          },
};

export const settingsSlice = createSlice({
    initialState,
    name: 'settingsSlice',
    reducers: {
        setFullPrice: (state, action: PayloadAction<boolean>) => {
            state.isFullPrice = action.payload;
        },
        setCurrency: (
            state,
            action: PayloadAction<{
                code: string;
                exchangeRate: string;
            }>,
        ) => {
            state.currency = action.payload;
            localStorage.setItem('currency', JSON.stringify(action.payload));
        },
    },
});

export default settingsSlice.reducer;

export const selectSettings = (state: { settingsState: ISettingsState }) => state.settingsState;

export const { setFullPrice, setCurrency } = settingsSlice.actions;
